import { apiProxyRequest } from "Api/apiProxyRequest";

import type { BaseIntegration } from "./types";

export const getIntegrationsRequest = (projectId: string) =>
  apiProxyRequest<BaseIntegration[]>(`/projects/${projectId}/integrations`);
